import {
  ArchitecturalPrincipleResponse,
  DesignCriteriaResponse,
  ProjectCharterOverviewResponse,
  ProjectCharterParametersResponse,
  ProjectCharterRolesAndStakeholdersResponse,
  ProjectCharterScopeResponse,
  ProjectTimeFrameResponse,
} from '@frontend/shared-api';

export interface CharterSection {
  key: string;
  fieldName: string;
  tooltipKey: string;
}

export interface CharterTab {
  tabKey: string;
  sections: CharterSection[];
  data?:
    | ProjectCharterOverviewResponse
    | ProjectCharterScopeResponse
    | ProjectCharterParametersResponse
    | ProjectCharterRolesAndStakeholdersResponse;
}

export interface CharterData {
  overview: ProjectCharterOverviewResponse;
  scope: ProjectCharterScopeResponse;
  parameters: ProjectCharterParametersResponse;
  rolesAndStakeholders: ProjectCharterRolesAndStakeholdersResponse;
  timeFrames: ProjectTimeFrameResponse[];
  designCriteria: DesignCriteriaResponse[];
  architecturalPrinciples: ArchitecturalPrincipleResponse[];
}

export const SECTION_KEYS = {
  COMPANY_PROFILE: 'company_profile',
  COMPANY_CORE_PRODUCTS: 'company_core_products',
  COMPANY_LONG_TERM_GOALS: 'company_long_term_goals',
  PROJECT_RATIONALE: 'project_rationale',
  PROJECT_DESCRIPTION: 'project_description',

  IN_SCOPE: 'in_scope',
  OUT_OF_SCOPE: 'out_of_scope',

  PROJECT_GOALS: 'project_goals',
  DELIVERABLES: 'deliverables',
  POTENTIAL_RISKS: 'potential_risks',
  REASONS_FOR_NEW_HR_SYSTEM: 'reasons_for_new_hr_system',

  PROJECT_ROLES_AND_RESPONSIBILITIES: 'project_roles_and_responsibilities',
  KEY_STAKEHOLDERS: 'key_stakeholders',
} as const;

export const CHARTER_TABS: CharterTab[] = [
  {
    tabKey: 'project.steps.projectChartTab1',
    sections: [
      {
        key: SECTION_KEYS.COMPANY_PROFILE,
        fieldName: 'companyProfile',
        tooltipKey: 'project.steps.projectChart.companyProfile',
      },
      {
        key: SECTION_KEYS.COMPANY_CORE_PRODUCTS,
        fieldName: 'companyCoreProducts',
        tooltipKey: 'project.steps.projectChart.companyCoreProduct',
      },
      {
        key: SECTION_KEYS.COMPANY_LONG_TERM_GOALS,
        fieldName: 'companiesLongTermGoals',
        tooltipKey: 'project.steps.projectChart.companyLongTermGoals',
      },
      {
        key: SECTION_KEYS.PROJECT_RATIONALE,
        fieldName: 'projectRationale',
        tooltipKey: 'project.steps.projectChart.projectRationale',
      },
      {
        key: SECTION_KEYS.PROJECT_DESCRIPTION,
        fieldName: 'projectDescription',
        tooltipKey: 'project.steps.projectChart.projectDescription',
      },
    ],
  },
  {
    tabKey: 'project.steps.projectChartTab2',
    sections: [
      {
        key: SECTION_KEYS.IN_SCOPE,
        fieldName: 'inScope',
        tooltipKey: 'project.steps.projectChart.inScope',
      },
      {
        key: SECTION_KEYS.OUT_OF_SCOPE,
        fieldName: 'outOfScope',
        tooltipKey: 'project.steps.projectChart.outOfScope',
      },
    ],
  },
  {
    tabKey: 'project.steps.projectChartTab3',
    sections: [
      {
        key: SECTION_KEYS.PROJECT_GOALS,
        fieldName: 'projectGoals',
        tooltipKey: 'project.steps.projectChart.projectGoals',
      },
      {
        key: SECTION_KEYS.DELIVERABLES,
        fieldName: 'deliverables',
        tooltipKey: 'project.steps.projectChart.deliverables',
      },
      {
        key: SECTION_KEYS.POTENTIAL_RISKS,
        fieldName: 'potentialRisks',
        tooltipKey: 'project.steps.projectChart.potentialRisks',
      },
      {
        key: SECTION_KEYS.REASONS_FOR_NEW_HR_SYSTEM,
        fieldName: 'reasonsForNewHrSystem',
        tooltipKey: 'project.steps.projectChart.reasonsForNewHrSystem',
      },
    ],
  },
  {
    tabKey: 'project.steps.projectChartTab4',
    sections: [
      {
        key: SECTION_KEYS.PROJECT_ROLES_AND_RESPONSIBILITIES,
        fieldName: 'projectRolesAndResponsibilities',
        tooltipKey: 'project.steps.projectChart.projectRolesAndResponsibilities',
      },
      {
        key: SECTION_KEYS.KEY_STAKEHOLDERS,
        fieldName: 'keyStakeholders',
        tooltipKey: 'project.steps.projectChart.keyStakeholders',
      },
    ],
  },
];
